import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent, IonItem } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import '../../../../css/qavaApp.css';


export function Tab_Kitchen (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate() - 3)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 1)));

    let [productPicsModal, setProductPicsModal] = useState(false);
    let [checkInModal, setCheckInModal] = useState(false);
    
    let [checkInModal_tracker, setCheckInModal_tracker] = useState(null);
    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    
    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);
    
    useEffect(() => {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_active_Orders_restaurantKitchen',
                    user: acctID,
                    xStartDateRange: startDate.toISOString().substr(0, 10),
                    xEndDateRange: endDate.toISOString().substr(0, 10),
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                order_id: cols[0],
                                cart_id: cols[1],
                                order_phone_number: cols[2],
                                client_first_name: cols[3],
                                client_last_name: cols[4],
                                client_phone_number: cols[5],
                                client_email_address: cols[6],
                                client_payment_type: cols[7],
                                client_member_number: cols[8],
                                client_mm_provider: cols[9],
                                client_mm_number: cols[10],
                                order_total: parseFloat(cols[11]).toFixed(2),
                                order_amt_paid: parseFloat(cols[12]).toFixed(2),
                                order_start_date_reserved: cols[13],
                                order_end_date_reserved: cols[14],
                                order_start_date: cols[15],
                                order_end_date: cols[16],
                                merchant_invoice_id: cols[17],
                                invoiceForm: cols[18],
                                customer_invoice_id: cols[19],
                                invoiceTotal: parseFloat(cols[20]).toFixed(2),
                                transactionID: cols[21],
                                totalInvoiceAmount: cols[22],
                                transactionStatus: cols[23],
                                momo_provider: cols[24],
                                momo_financial_transaction_id: cols[25],
                                momo_external_id: cols[26],
                                momo_amount: cols[27],
                                momo_party_id: cols[28],
                                momo_payer_message: cols[29],
                                momo_payee_note: cols[30],
                                momo_pay_status: cols[31],
                                payment_type: cols[32],
                                verify_id_type: cols[33],
                                verify_id_number: cols[34],
                                ship_to_address: cols[35],
                                latitude: cols[36],
                                longitude: cols[37],
                                status: cols[38],


                            });
                        });
                    }
                });
    }, []);
    
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }
    
    return (
        <React.Fragment>

                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol size="12">
                                <IonText> Active Orders </IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>

                <IonItem>
                    <IonGrid>
                        <IonRow style={{border: '2px solid black' }}>
                            <IonCol size='2'>
                                <IonText> ID </IonText>
                            </IonCol>
                            <IonCol size='3'>
                                <IonText> Name </IonText>
                            </IonCol>
                            <IonCol size='4'>
                                <IonText> Total </IonText>
                            </IonCol>
                            <IonCol size='3'>
                                <IonText> Action </IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>
            <IonContent className='appContent_restaurant_kitchen'>           

                        <IonGrid>
                            {viewInventoryAvailableProducts.map((detailData) => {
                                return (
                                    <IonRow key={detailData.order_id}>
                                        <IonCol size='2'>{detailData.order_id}</IonCol>
                                        <IonCol size='2'>{detailData.client_first_name+" "+detailData.client_last_name}</IonCol>
                                        <IonCol size='5'>{detailData.invoiceTotal}</IonCol>
                                        <IonCol size='3'>
                                            <IonButton class='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, detailData.order_id, detailData.invoiceTotal, detailData.invoiceForm])}> View </IonButton>
                                            <IonButton>Details</IonButton>
                                        </IonCol>
                                    </IonRow>
                                );
                            })}
                        </IonGrid>
    
                    {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: invoiceForm, 
                                        roomID: orderID, 
                                        roomSalePrice: orderTotal,
                                        }}></ViewInvoiceModal>}
            </IonContent>
        </React.Fragment>

    )
}